angular.module('jcsfApp').constant('events', {
    message: {
        _GET_STUDENT_FULL_LIST_:'_GET_STUDENT_FULL_LIST_',
        _GET_FOREST_LIST_: '_GET_FOREST_LIST_',
        _GET_FOREST_LIST_COMPLETE_: '_GET_FOREST_LIST_COMPLETE_',
        _GET_FOREST_LIST_FAILED_: '_GET_FOREST_LIST_FAILED_',
        _CHECK_STUDENT_EMAIL_EXIST_: '_CHECK_STUDENT_EMAIL_EXIST_',
        _CHECK_STUDENT_EMAIL_EXIST_COMPLETE_: '_CHECK_STUDENT_EMAIL_EXIST_COMPLETE_',
        _CHECK_STUDENT_EMAIL_EXIST_FAILED_: '_CHECK_STUDENT_EMAIL_EXIST_FAILED_',
        _GET_FOREST_SERVICE_PROJECT_LIST_: '_GET_FOREST_SERVICE_PROJECT_LIST_',
        _GET_FOREST_SERVICE_PROJECT_LIST_COMPLETE_: '_GET_FOREST_SERVICE_PROJECT_LIST_COMPLETE_',
        _GET_FOREST_SERVICE_PROJECT_LIST_FAILED_: '_GET_FOREST_SERVICE_PROJECT_LIST_FAILED_',
        _GET_STUDENT_FSHOURS_LIST_: '_GET_STUDENT_FSHOURS_LIST_',
        _GET_SUMMARY_REPORT_LIST_: '_GET_SUMMARY_REPORT_LIST_',
        _GET_SUMMARY_REPORT_LIST_COMPLETE_: '_GET_SUMMARY_REPORT_LIST_COMPLETE_',
        _GET_SUMMARY_REPORT_LIST_FAILED_: '_GET_SUMMARY_REPORT_LIST_FAILED_',
        _GET_STUDENT_FSHOURS_LIST_: '_GET_STUDENT_FSHOURS_LIST_',
        _GET_STUDENT_FSHOURS_LIST_COMPLETE_: '_GET_STUDENT_FSHOURS_LIST_COMPLETE_',
        _GET_STUDENT_FSHOURS_LIST_FAILED_: '_GET_STUDENT_FSHOURS_LIST_FAILED_',
        _GET_STUDENT_FIREHOURS_LIST_: '_GET_STUDENT_FIREHOURS_LIST_',
        _GET_STUDENT_FIREHOURS_LIST_COMPLETE_: '_GET_STUDENT_FIREHOURS_LIST_COMPLETE_',
        _GET_STUDENT_FIREHOURS_LIST_FAILED_: '_GET_STUDENT_FIREHOURS_LIST_FAILED_',
        _GET_STUDENT_COMMUNITYHOURS_LIST_: '_GET_STUDENT_COMMUNITYHOURS_LIST_',
        _GET_STUDENT_COMMUNITYHOURS_LIST_COMPLETE_: '_GET_STUDENT_COMMUNITYHOURS_LIST_COMPLETE_',
        _GET_STUDENT_COMMUNITYHOURS_LIST_FAILED_: '_GET_STUDENT_COMMUNITYHOURS_LIST_FAILED_',
        _GET_FS1800_16_LIST_: '_GET_FS1800_16_LIST_',
        _GET_FS1800_16_LIST_COMPLETE_: '_GET_FS1800_16_LIST_COMPLETE_',
        _GET_FS1800_16_LIST_FAILED_: '_GET_FS1800_16_LIST_FAILED_',
        _GET_YOUTHANDVOLUNTEER_LIST_: '_GET_YOUTHANDVOLUNTEER_LIST_',
        _GET_YOUTHANDVOLUNTEER_LIST_COMPLETE_: '_GET_YOUTHANDVOLUNTEER_LIST_COMPLETE_',
        _GET_YOUTHANDVOLUNTEER_LIST_FAILED_: '_GET_YOUTHANDVOLUNTEER_LIST_FAILED_',
        _GET_PLC_TOTAL_HOURS_LIST_: '_GET_PLC_TOTAL_HOURS_LIST_',
        _GET_PLC_TOTAL_HOURS_LIST_COMPLETE_: '_GET_PLC_TOTAL_HOURS_LIST_COMPLETE_',
        _GET_PLC_TOTAL_HOURS_LIST_FAILED_: '_GET_PLC_TOTAL_HOURS_LIST_FAILED_',

        _GET_STUDENT_DELETED_LIST_: '_GET_STUDENT_DELETED_LIST_',
        _GET_STUDENT_DELETED_LIST_COMPLETE_: '_GET_STUDENT_DELETED_LIST_COMPLETE_',
        _GET_STUDENT_DELETED_LIST_FAILED_: '_GET_STUDENT_DELETED_LIST_FAILED_',
        _GET_STUDENT_LIST_: '_GET_STUDENT_LIST_',
        _GET_STUDENT_LIST_COMPLETE_: '_GET_STUDENT_LIST_COMPLETE_',
        _GET_STUDENT_LIST_FAILED_: '_GET_STUDENT_LIST_FAILED_',
        _STUDENT_RECALL_: '_STUDENT_RECALL_',
        _STUDENT_RECALL_COMPLETE_: '_STUDENT_RECALL_COMPLETE_',
        _STUDENT_RECALL_FAILED_: '_STUDENT_RECALL_FAILED_',
        _GET_STUDENT_: '_GET_STUDENT_',
        _GET_STUDENT_COMPLETE_: '_GET_STUDENT_COMPLETE_',
        _GET_STUDENT_FAILED_: '_GET_STUDENT_FAILED_',
        _SAVE_STUDENT_: '_SAVE_STUDENT_',
        _SAVE_STUDENT_COMPLETE_: '_SAVE_STUDENT_COMPLETE_',
        _SAVE_STUDENT_FAILED_: '_SAVE_STUDENT_FAILED_',
        _MAIL_NOTIFICATION_:'_MAIL_NOTIFICATION_',
        _MAIL_NOTIFICATION_FAILED_: '_MAIL_NOTIFICATION_FAILED_',
        _MAIL_NOTIFICATION_COMPLETE_:'_MAIL_NOTIFICATION_COMPLETE_',
        _DELETE_STUDENT_: '_DELETE_STUDENT_',
        _DELETE_STUDENT_COMPLETE_: '_DELETE_STUDENT_COMPLETE_',
        _DELETE_STUDENT_FAILED_: '_DELETE_STUDENT_FAILED_',
        _SAVE_FIRE_HOUR_: '_SAVE_FIRE_HOUR_',
        _SAVE_FIRE_HOUR_COMPLETE_: '_SAVE_FIRE_HOUR_COMPLETE_',
        _SAVE_FIRE_HOUR_FAILED_: '_SAVE_FIRE_HOUR_FAILED_',
        _DELETE_FIRE_HOUR_: '_DELETE_FIRE_HOUR_',
        _DELETE_FIRE_HOUR_COMPLETE_: '_DELETE_FIRE_HOUR_COMPLETE_',
        _DELETE_FIRE_HOUR_FAILED_: '_DELETE_FIRE_HOUR_FAILED_',
        _SAVE_STUDENT_HOUR_: '_SAVE_STUDENT_HOUR_',
        _SAVE_STUDENT_HOUR_COMPLETE_: '_SAVE_STUDENT_HOUR_COMPLETE_',
        _SAVE_STUDENT_HOUR_FAILED_: '_SAVE_STUDENT_HOUR_FAILED_',
        _DELETE_STUDENT_HOUR_: '_DELETE_STUDENT_HOUR_',
        _DELETE_STUDENT_HOUR_COMPLETE_: '_DELETE_STUDENT_HOUR_COMPLETE_',
        _DELETE_STUDENT_HOUR_FAILED_: '_DELETE_STUDENT_HOUR_FAILED_',
        _SAVE_SUCCESS_: '_SAVE_SUCCESS_',
        _SAVE_NON_PUBLIC_HOUR_: '_SAVE_NON_PUBLIC_HOUR_',
        _SAVE_NON_PUBLIC_HOUR_COMPLETE_: '_SAVE_NON_PUBLIC_HOUR_COMPLETE_',
        _SAVE_NON_PUBLIC_HOUR_FAILED_: '_SAVE_NON_PUBLIC_HOUR_FAILED_',
        _DELETE_NON_PUBLIC_HOUR_: '_DELETE_NON_PUBLIC_HOUR_',
        _DELETE_NON_PUBLIC_HOUR_COMPLETE_: '_DELETE_NON_PUBLIC_HOUR_COMPLETE_',
        _DELETE_NON_PUBLIC_HOUR_FAILED_: '_DELETE_NON_PUBLIC_HOUR_FAILED_',
        _GET_STUDENT_RESOURCES_LIST_: '_GET_STUDENT_RESOURCES_LIST_',
        _GET_STUDENT_RESOURCES_LIST_COMPLETE_: '_GET_STUDENT_RESOURCES_LIST_COMPLETE_',
        _GET_STUDENT_RESOURCES_LIST_FAILED_: '_GET_STUDENT_RESOURCES_LIST_FAILED_',
        _GET_JCCENTER_LIST_: '_GET_JCCENTER_LIST_',
        _GET_JCCENTER_LIST_COMPLETE_: '_GET_JCCENTER_LIST_COMPLETE_',
        _GET_JCCENTER_LIST_FAILED_: '_GET_JCCENTER_LIST_FAILED_',
        _GET_JCCENTER_: '_GET_JCCENTER_',
        _GET_JCCENTER_COMPLETE_: '_GET_JCCENTER_COMPLETE_',
        _GET_JCCENTER_FAILED_: '_GET_JCCENTER_FAILED_',
        _SAVE_JCCENTER_: '_SAVE_JCCENTER_',
        _SAVE_JCCENTER_COMPLETE_: '_SAVE_JCCENTER_COMPLETE_',
        _SAVE_JCCENTER_FAILED_: '_SAVE_JCCENTER_FAILED_',
        _DELETE_JCCENTER_: '_DELETE_JCCENTER_',
        _DELETE_JCCENTER_COMPLETE_: '_DELETE_JCCENTER_COMPLETE_',
        _DELETE_JCCENTER_FAILED_: '_DELETE_JCCENTER_FAILED_',
        _GET_FOREST_PROJECT_FAILED: "_GET_FOREST_PROJECT_FAILED",
        _GET_FOREST_PROJECT_: "_GET_FOREST_PROJECT_",
        _GET_FOREST_PROJECT_COMPLETE_: "_GET_FOREST_PROJECT_COMPLETE_",
        _SAVE_FOREST_PROJECT_FAILED: "_SAVE_FOREST_PROJECT_FAILED",
        _SAVE_FOREST_PROJECT_: "_SAVE_FOREST_PROJECT_",
        _SAVE_FOREST_PROJECT_COMPLETE_: "_SAVE_FOREST_PROJECT_COMPLETE_",
        _GET_CENTER_HOURS_LIST_FAILED: "_GET_CENTER_HOURS_LIST_FAILED",
        _GET_CENTER_HOURS_LIST_: "_GET_CENTER_HOURS_LIST_",
        _GET_CENTER_HOURS_LIST_COMPLETE_: "_GET_CENTER_HOURS_LIST_COMPLETE_",
        _GET_RSA_LIST_: '_GET_RSA_LIST_',
        _GET_RSA_LIST_COMPLETE_: '_GET_RSA_LIST_COMPLETE_',
        _GET_RSA_LIST_FAILED_: '_GET_RSA_LIST_FAILED_',
        _GET_RSA_: '_GET_RSA_',
        _GET_RSA_COMPLETE_: '_GET_RSA_COMPLETE_',
        _GET_RSA_FAILED_: '_GET_RSA_FAILED_',
        _SAVE_RSA_: '_SAVE_RSA_',
        _SAVE_RSA_COMPLETE_: '_SAVE_RSA_COMPLETE_',
        _SAVE_RSA_FAILED_: '_SAVE_RSA_FAILED_',
        _DELETE_RSA_: '_DELETE_RSA_',
        _DELETE_RSA_COMPLETE_: '_DELETE_RSA_COMPLETE_',
        _DELETE_RSA_FAILED_: '_DELETE_RSA_FAILED_',

        _GET_PROJECT_RESOURCES_LIST_: '_GET_PROJECT_RESOURCES_LIST_',
        _GET_PROJECT_RESOURCES_LIST_COMPLETE_: '_GET_PROJECT_RESOURCES_LIST_COMPLETE_',
        _GET_PROJECT_RESOURCES_LIST_FAILED_: '_GET_PROJECT_RESOURCES_LIST_FAILED_',
        _GET_PROJECT_LIST_: '_GET_PROJECT_LIST_',
        _GET_PROJECT_LIST_COMPLETE_: '_GET_PROJECT_LIST_COMPLETE_',
        _GET_PROJECT_LIST_FAILED_: '_GET_PROJECT_LIST_FAILED_',
        _GET_PROJECT_: '_GET_PROJECT_',
        _GET_PROJECT_COMPLETE_: '_GET_PROJECT_COMPLETE_',
        _GET_PROJECT_FAILED_: '_GET_PROJECT_FAILED_',
        _SAVE_PROJECT_: '_SAVE_PROJECT_',
        _SAVE_PROJECT_COMPLETE_: '_SAVE_PROJECT_COMPLETE_',
        _SAVE_PROJECT_FAILED_: '_SAVE_PROJECT_FAILED_',
        _DELETE_PROJECT_: '_DELETE_PROJECT_',
        _DELETE_PROJECT_COMPLETE_: '_DELETE_PROJECT_COMPLETE_',
        _DELETE_PROJECT_FAILED_: '_DELETE_PROJECT_FAILED_',

        _DELETE_PROJECT_FS_: '_DELETE_PROJECT_FS_',
        _DELETE_PROJECT_FS_COMPLETE_: '_DELETE_PROJECT_FS_COMPLETE_',
        _DELETE_PROJECT_FS_FAILED_: '_DELETE_PROJECT_FS_FAILED_',

        _GET_NON_PUBLIC_PROJECT_LIST_: '_GET_NON_PUBLIC_PROJECT_LIST_',
        _GET_NON_PUBLIC_PROJECT_LIST_COMPLETE_: '_GET_NON_PUBLIC_PROJECT_LIST_COMPLETE_',
        _GET_NON_PUBLIC_PROJECT_LIST_FAILED_: '_GET_NON_PUBLIC_PROJECT_LIST_FAILED_',
        _GET_NON_PUBLIC_PROJECT_: '_GET_NON_PUBLIC_PROJECT_',
        _GET_NON_PUBLIC_PROJECT_COMPLETE_: '_GET_NON_PUBLIC_PROJECT_COMPLETE_',
        _GET_NON_PUBLIC_PROJECT_FAILED_: '_GET_NON_PUBLIC_PROJECT_FAILED_',
        _SAVE_NON_PUBLIC_PROJECT_: '_SAVE_NON_PUBLIC_PROJECT_',
        _SAVE_NON_PUBLIC_PROJECT_COMPLETE_: '_SAVE_NON_PUBLIC_PROJECT_COMPLETE_',
        _SAVE_NON_PUBLIC_PROJECT_FAILED_: '_SAVE_NON_PUBLIC_PROJECT_FAILED_',
        _DELETE_NON_PUBLIC_PROJECT_: '_DELETE_NON_PUBLIC_PROJECT_',
        _DELETE_NON_PUBLIC_PROJECT_COMPLETE_: '_DELETE_NON_PUBLIC_PROJECT_COMPLETE_',
        _DELETE_NON_PUBLIC_PROJECT_FAILED_: '_DELETE_NON_PUBLIC_PROJECT_FAILED_',
        _ADD_ERROR_MESSAGE_: '_ADD_ERROR_MESSAGE_',
        _CLEAR_ERROR_MESSAGES_: '_CLEAR_ERROR_MESSAGES_',
        _ERROR_MESSAGES_UPDATED_: '_ERROR_MESSAGES_UPDATED_',
        _ADD_USER_MESSAGE_: '_ADD_USER_MESSAGE_',
        _CLEAR_USER_MESSAGES_: '_CLEAR_USER_MESSAGES_',
        _USER_MESSAGES_UPDATED_: '_USER_MESSAGES_UPDATED_',
        _DISPLAY_CONFIRMATION_INPUT_: '_DISPLAY_CONFIRMATION_INPUT_',
        _EDIT_ITEM_: '_EDIT_ITEM_',

        _USER_RESPONDED_: '_USER_RESPONDED_',
        _SERVER_REQUEST_STARTED_: '_SERVER_REQUEST_STARTED_',
        _SERVER_REQUEST_ENDED_: '_SERVER_REQUEST_ENDED_',
        _GET_USER_BY_USERNAME_: '_GET_USER_BY_USERNAME_',
        _GET_USER_BY_USERNAME_COMPLETE_: '_GET_USER_BY_USERNAME_COMPLETE_',
        _GET_USER_BY_USERNAME_FAILED_: '_GET_USER_BY_USERNAME_FAILED_',
        _GET_USER_BY_EMAIL_: '_GET_USER_BY_EMAIL_',
        _GET_USER_BY_EMAIL_COMPLETE_: '_GET_USER_BY_EMAIL_COMPLETE_',
        _GET_USER_BY_EMAIL_FAILED_: '_GET_USER_BY_EMAIL_FAILED_',
        _GET_USERS_: '_GET_USERS_',
        _GET_USERS_COMPLETE_: '_GET_USERS_COMPLETE_',
        _GET_USERS_FAILED_: '_GET_USERS_FAILED_',
        _GET_USER_BY_Id_: '_GET_USER_BY_Id_',
        _GET_USER_BY_Id_COMPLETE_: '_GET_USER_BY_Id_COMPLETE_',
        _GET_USER_BY_Id_FAILED_: '_GET_USER_BY_Id_FAILED_',
        _CREATE_USER_: '_CREATE_USER_',
        _CREATE_USER_COMPLETE_: '_CREATE_USER_COMPLETE_',
        _CREATE_USER_FAILED_: '_CREATE_USER_FAILED_',
        _UPDATE_USER_: '_UPDATE_USER_',
        _UPDATE_USER_COMPLETE_: '_UPDATE_USER_COMPLETE_',
        _UPDATE_USER_FAILED_: '_UPDATE_USER_FAILED_',
        _DELETE_USER_: '_DELETE_USER_',
        _DELETE_USER_COMPLETE_: '_DELETE_USER_COMPLETE_',
        _DELETE_USER_FAILED_: '_DELETE_USER_FAILED_',
        _REQUEST_CURRENT_USER_: '_REQUEST_CURRENT_USER_',
        _CURRENT_USER_RESPONSE_: '_CURRENT_USER_RESPONSE_',

        _GET_FIRE_HOUR_DATA_LIST_: '_GET_FIRE_HOUR_DATA_LIST_',
        _GET_FIRE_HOUR_DATA_LIST_COMPLETE_: '_GET_FIRE_HOUR_DATA_LIST_COMPLETE_',
        _GET_FIRE_HOUR_DATA_LIST_FAILED_: '_GET_FIRE_HOUR_DATA_LIST_FAILED_',
        _GET_FIRE_SAFETY_DATA_LIST_: '_GET_FIRE_SAFETY_DATA_LIST_',
        _GET_FIRE_SAFETY_DATA_LIST_COMPLETE_: '_GET_FIRE_SAFETY_DATA_LIST_COMPLETE_',
        _GET_FIRE_SAFETY_DATA_LIST_FAILED_: '_GET_FIRE_SAFETY_DATA_LIST_FAILED_',
        _GET_COMMUNITY_DATA_LIST_: '_GET_COMMUNITY_DATA_LIST_',
        _GET_COMMUNITY_DATA_LIST_COMPLETE_: '_GET_COMMUNITY_DATA_LIST_COMPLETE_',
        _GET_COMMUNITY_DATA_LIST_FAILED_: '_GET_COMMUNITY_DATA_LIST_FAILED_',

        _AUTHENTICATE_USER_: '_AUTHENTICATE_USER_',
        _AUTHENTICATE_USER_COMPLETE_: '_AUTHENTICATE_USER_COMPLETE_',
        _AUTHENTICATE_USER_FAILED_: '_AUTHENTICATE_USER_FAILED_',
        _USER_LOGOUT_: '_USER_LOGOUT_',
        _USER_LOGOUT_COMPLETE_: '_USER_LOGOUT_COMPLETE_',

        _REGISTER_USER_COMPLETE_: '_REGISTER_USER_COMPLETE_',
        _REGISTER_USER_FAILED_: '_REGISTER_USER_FAILED_',
        _REGISTER_USER_: '_REGISTER_USER_',

        _LOG_TRACE_: '_LOG_TRACE_',
        _LOG_DEBUG_: '_LOG_DEBUG_',
        _LOG_INFO_: '_LOG_INFO_',
        _LOG_WARNING_: '_LOG_WARNING_',
        _LOG_ERROR_: '_LOG_ERROR_',
        _LOG_FATAL_: '_LOG_FATAL_'
    }
});
